import axios from "axios";
import { CONFIG } from "../../config";
export const LoginServices = async (loginData) => {
	try {
		const response = await axios.post(
			`${CONFIG.AUTHURL}/api/v2/student/login`,
			loginData
		);
		return response.data;
	} catch (error) {
		console.error(error);
		// Never return undefined here. LoginScreen.js unconditionally reads data.msg on
		// whatever this function returns (data.msg === "Successful" ...) - returning
		// undefined on any failure (wrong password -> 401, network error, timeout, CORS
		// issue, etc.) caused "Cannot read properties of undefined (reading 'msg')" any
		// time login failed for any reason, not specifically a Forgot Password defect.
		// Returning a Status/msg-shaped object here lets LoginScreen.js's existing
		// failure branch (already written to handle msg !== "Successful") work correctly.
		return {
			Status: "UnSuccessful",
			msg: error?.response?.data?.msg || "Please enter the Correct Username & Password",
		};
	}
};
